/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationDropdownContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_settings" | "UserBanPopoverContainer_settings">;
    readonly " $refType": "ModerationDropdownContainer_settings";
};
export type ModerationDropdownContainer_settings$data = ModerationDropdownContainer_settings;
export type ModerationDropdownContainer_settings$key = {
    readonly " $data"?: ModerationDropdownContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationDropdownContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationActionsContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBanPopoverContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '98b775febc858279ca8e798159975742';
export default node;
